import ViewerSidebar from "../components/ViewerSidebar";
import StatisticsReport from "../components/StatisticsReport";

export default function ViewerStatistics() {
  return <StatisticsReport Sidebar={ViewerSidebar} />;
}
